import React, { FC } from 'react';
import { langExistsInPath } from '@global/localization/services';
import { langExistsInPathList } from '@global/localization/i18n';
import PageLayout from '@src/layouts/PageLayout';
import { Page404 } from '@pages/404';
import { SiteConfig } from '../utils/SiteConfig';

interface IProps {
  path: string;
  children: React.ReactNode;
}

const RouteWrapper: FC<IProps> = ({ path, children }) => {
  if (SiteConfig.isNonLocalizedSite()) {
    return <PageLayout path={path}>{children}</PageLayout>;
  }

  return langExistsInPath(langExistsInPathList) ? (
    <PageLayout path={path}>{children}</PageLayout>
  ) : (
    <PageLayout path={path}>
      <Page404 />
    </PageLayout>
  );
};

export default React.memo(RouteWrapper);
